<template>
  <div>
    <component v-for="(value, index) in componentList" :key="index + reloadLangKey"
      :is="value"
      @lang="onChangeLang()"
      @selected="onScroll($event)"
      class="section">
    </component>
  </div>
</template>

<script>
import Cover from './Cover.vue';
import Resume from './Resume.vue';
import Experience from './Experience.vue';
import Contact from './Contact.vue';
import Navbar from './Navbar.vue';
import Education from './Education.vue';
import Code from './Code.vue';

export default {
  components: {
    Cover,
    Resume,
    Experience,
    Contact,
    Navbar,
    Education,
    Code,
  },
  data() {
    return {
      componentList: [
        'Navbar',
        'Cover',
        'Resume',
        'Experience',
        'Education',
        'Code',
        'Contact',
      ],
      reloadLangKey: 0,
    };
  },
  methods: {
    onScroll(selectedComponent) {
      var element = document.getElementById(selectedComponent);
      element.scrollIntoView({behavior: 'smooth'});
    },
    onChangeLang() {
      this.reloadLangKey += 1;
    },
  },
};
</script>